import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';
import { MaterialModule } from '../../../shared/material.module';

interface SidebarNavItem {
  label: string;
  route: string;
  icon: string;
}

@Component({
  selector: 'app-main-layout',
  standalone: true,
  imports: [CommonModule, RouterLink, RouterLinkActive, RouterOutlet, MaterialModule],
  templateUrl: './main-layout.component.html',
  styleUrls: ['./main-layout.component.scss']
})
export class MainLayoutComponent {
  navItems: SidebarNavItem[] = [
    { label: 'Admin. de Usuarios', route: '/userlist', icon: 'group' },
    { label: 'Notificaciones', route: '/notificaciones', icon: 'notifications' }
  ];
}
